/**
 * What the sticky label column of a horizontal schedule timeline is covering.
 *
 * The hour labels and the current-time pill are centred on their timeline
 * offset, so they stick out half their width to the left. Near the start of the
 * timeline — or once it has been scrolled — that half hangs over the stage and
 * custom-subject labels. Nothing may show up there, so anything centred hides
 * until it is fully clear of the column.
 */

/**
 * Half the width of a centred overlay. Sized on the widest label we render
 * ("10:00 AM" in 12h mode, ~62px at text-sm); 24h labels are narrower, so they
 * simply hide a few pixels earlier than strictly needed.
 */
export const CENTERED_OVERLAY_HALF_WIDTH = 32;

/**
 * Smallest timeline offset (px from the timeline's start hour) at which a
 * centred overlay is fully clear of the sticky label column.
 *
 *   scrollLeft    — how far the timeline is scrolled horizontally.
 *   canvasPadding — padding between the scroll container and the rows (the
 *                   read-only canvas has p-4; the creator has none). While the
 *                   timeline is scrolled less than that, the column has not
 *                   started sticking yet and only the half-width matters.
 */
export function firstVisibleOffset(
  scrollLeft: number,
  canvasPadding = 0,
  halfWidth: number = CENTERED_OVERLAY_HALF_WIDTH,
): number {
  return Math.max(0, scrollLeft - canvasPadding) + halfWidth;
}
